import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { Routes, RouterModule } from '@angular/router';

import { APP_ROUTER_PROVIDERS } from "../../app.routes";

import { NavigationMenu } from "../../model/index";

import { NavigationService } from "./navigation.service";

import { SecurityService } from "../../security/security.service";
declare var require: any;

@Component({
    selector: 'MentisSoft-Navigation',
    template: require('./Navigation.template.html'),
    styles: [require('./Navigation.css')],
    providers: [NavigationService, SecurityService]
})

export class NavigationComponent implements OnInit {

  
    constructor(private router: Router, private route: ActivatedRoute, private _navigationService: NavigationService,
        private _SecurityService: SecurityService) {
        this.IsAdminUser = this._SecurityService.IsAdminUser;
    }
    
    IsAdminUser: boolean = false;
    HospitalName: string = "";
    MenuHeader: string = "";

    IsInsuranceVisible: boolean = false;
    IsServiceVisible: boolean = false;
    IsAppointmentVisible: boolean = false;
    IsAdvanceVisible: boolean = false;
    IsAllergyVisible: boolean = false;
    IsScheduleVisible: boolean = false;
    IsRadiologyVisible: boolean = false;
    IsLabVisible: boolean = false;
    IsImmunizationVisible: boolean = false;
    IsMedicationVisible: boolean = false;
    IsDocuments: boolean = false;
    IsProcedureVisible: boolean = false;
    IsMedicalReportVisible: boolean = false;
	IsMedicalRequestVisible: boolean = false;
    IsRoleId: boolean = false;
    navigation: NavigationMenu = new NavigationMenu();
    ngOnInit() {       
        this.LoadMenusVisibility();
        this.IsAdminUser = JSON.parse(localStorage.getItem("ISAdmin")); 
        this.HospitalName = localStorage.getItem("HospitalName"); 
        if (this.HospitalName == "BSH")
            this.MenuHeader = "Medical Records";
        else
            this.MenuHeader = "Appointments & Records";
        if ((JSON.parse(localStorage.getItem("RoleId"))) == "2")
            this.IsRoleId = true;
    }
    ngAfterViewInit(): void {
    }
    LoadMenusVisibility() {       
        this._navigationService.getMenuVisibility(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid,  this._SecurityService.IsAdminUser)
            .subscribe(
            p => {
                this.navigation = p;
                for (var i = 0; i < p.length; i++) {
                    if (p[i].menuName =="APPOINTMENT REQUEST" && p[i].IsVisible == true) {                       
                        this.IsAppointmentVisible = true;
                    }
                    if (p[i].menuName == "SERVICE PAYMENT" && p[i].IsVisible == true) {
                        this.IsServiceVisible = true;
                    }
                    if (p[i].menuName == "ADVANCE PAYMENT" && p[i].IsVisible == true) {
                        this.IsAdvanceVisible = true;
                    }
                    if (p[i].menuName == "ALLERGY" && p[i].IsVisible == true) {
                        this.IsAllergyVisible = true;
                    }
                    if (p[i].menuName == "MEDICATIONS" && p[i].IsVisible == true) {
                        this.IsMedicationVisible = true;
                    }
                    if (p[i].menuName == "IMMUNIZATIONS" && p[i].IsVisible == true) {
                        this.IsImmunizationVisible = true;
                    }
                    if (p[i].menuName == "LAB RESULTS" && p[i].IsVisible == true) {
                        this.IsLabVisible = true;
                    }
                    if (p[i].menuName == "RADIOLOGY RESULTS" && p[i].IsVisible == true) {
                        this.IsRadiologyVisible = true;
                    }
                    if (p[i].menuName == "SCHEDULED APPOINTMENTS" && p[i].IsVisible == true) {
                        this.IsScheduleVisible = true;
                    }
                    if (p[i].menuName == "INSURANCE STATUS" && p[i].IsVisible == true) {
                        this.IsInsuranceVisible = true;
                    }  
                    if (p[i].menuName == "DOCUMENTS" && p[i].IsVisible == true) {
                        this.IsDocuments = true;
                    }              
                    if (p[i].menuName == "PROCEDURE RESULTS" && p[i].IsVisible == true) {
                        this.IsProcedureVisible = true;
                    }
                    if (p[i].menuName == "MEDICAL REPORTS" && p[i].IsVisible == true) {
                        this.IsMedicalReportVisible = true;
                    } 
					if (p[i].menuName == "MEDICAL REPORT REQUEST" && p[i].IsVisible == true) {
                        this.IsMedicalRequestVisible = true;
                    }      
                }     
            },
            err => {                
                console.log("Error while validating...");
            });
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/shared/navigation/Navigation.Component.ts